import { Outlet } from 'react-router-dom';

import './scss/main.scss';

function App() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default App;
